module.exports = __webpack_public_path__ + "static/img/ctyiyuan3.bd88ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctyiyuan3.png
// module id = mAON
// module chunks = 5